import './HomePricing.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PriceBgImage from './images/home-pricing-bg.jpg'

function HomePricing(){
    return(
        <div className='home-pricing' id='pricing'>
            <img className='pricingbg' src={PriceBgImage} />
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading2'>Pricing</h2>
                    </div>
                    <div className='col-md-12'>
                        <Tabs>
                            <TabList>
                                <Tab>Register New LEI Application</Tab>
                                <Tab>Renewal Application</Tab>
                            </TabList>
                            <TabPanel>
                                <div className='responsive-table'>
                                    <table>
                                        <tr>
                                            <th>Multi-Year Contract Option</th>
                                            <th>SEZ</th>
                                            <th colspan="2">Non SEZ (inclusive of 18% GST)</th>
                                        </tr>
                                        <tr className='light-yellow'>
                                            <td>Plan</td>
                                            <td>Price</td>
                                            <td>Fees + 18% GST</td>
                                            <td>Total Fees</td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>5th Years New Application & Renewal fFor 4 Years</td>
                                            <td><span className='orange-text'>14,750</span> ₹ / year</td>
                                            <td><span className='blue-text'>14,750+ 2,655</span></td>
                                            <td><span className='light-blue-text'>14,750+ 2,655</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>4th Years New Application & Renewal for Next 3 Years</td>
                                            <td><span className='orange-text'>12,350</span> ₹ / year</td>
                                            <td><span className='blue-text'>12,350+ 2,223</span></td>
                                            <td><span className='light-blue-text'>14,573/-</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>3nd Years New Application & Renewal for Next 2 Years</td>
                                            <td><span className='orange-text'>9,750</span> ₹ / year</td>
                                            <td><span className='blue-text'>9,750+ 1,755</span></td>
                                            <td><span className='light-blue-text'>11,505/-</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>2nd Years New Application & Renewal for Next 1 Year</td>
                                            <td><span className='orange-text'>7,100</span> ₹ / year</td>
                                            <td><span className='blue-text'>7100+ 1,278</span></td>
                                            <td><span className='light-blue-text'>8,378/-</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>1st Year New Application </td>
                                            <td><span className='orange-text'>4,250</span> ₹ / year</td>
                                            <td><span className='blue-text'>4,250 + 765</span></td>
                                            <td><span className='light-blue-text'>5015</span></td>
                                        </tr>
                                    </table>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className='responsive-table'>
                                    <table>
                                        <tr>
                                            <th>Multi-Year Contract Option</th>
                                            <th>SEZ</th>
                                            <th colspan="2">Non SEZ (inclusive of 18% GST)</th>
                                        </tr>
                                        <tr className='light-yellow'>
                                            <td>Plan</td>
                                            <td>Price</td>
                                            <td>Fees + 18% GST</td>
                                            <td>Total Fees</td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>Renewal application for 5 years</td>
                                            <td><span className='orange-text'>13,500</span> ₹ / year</td>
                                            <td><span className='blue-text'>13,500+ 2,430</span></td>
                                            <td><span className='light-blue-text'>15,930</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>Renewal application for 4 years</td>
                                            <td><span className='orange-text'>11,100</span> ₹ / year</td>
                                            <td><span className='blue-text'>11,100+ 1998</span></td>
                                            <td><span className='light-blue-text'>13,098</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>Renewal application for 3 years</td>
                                            <td><span className='orange-text'>8,500</span> ₹ / year</td>
                                            <td><span className='blue-text'>8,500+ 1,530</span></td>
                                            <td><span className='light-blue-text'>10,030</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>Renewal application for 2 years</td>
                                            <td><span className='orange-text'>5,850</span> ₹ / year</td>
                                            <td><span className='blue-text'>5850+ 1,053</span></td>
                                            <td><span className='light-blue-text'>6,903</span></td>
                                        </tr>
                                        <tr className='whitebg'>
                                            <td>Renewal application for 1 year</td>
                                            <td><span className='orange-text'>3,000</span> ₹ / year</td>
                                            <td><span className='blue-text'>3000+ 540</span></td>
                                            <td><span className='light-blue-text'>3,540</span></td>
                                        </tr>
                                    </table>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}export default HomePricing;